.wrap {
  max-width: 620px;
  margin: 40px auto 80px;
  padding: 0 20px;
}
.eyebrow {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--blue-text);
  margin-bottom: 6px;
}
.wrap h1 {
  font-size: 28px;
}
.intro {
  color: var(--muted);
  margin: 8px 0 22px;
  font-size: 14.5px;
}
.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px 26px;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.label {
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
  letter-spacing: 0.02em;
  margin-top: 12px;
}
.card input[type="text"],
.card input[type="file"] {
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  background: #fff;
}
.card input[type="text"]:focus {
  outline: none;
  border-color: var(--blue-l);
  box-shadow: 0 0 0 3px rgba(12, 134, 188, 0.35);
}
.note {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}
.alert {
  background: var(--amber-bg);
  border: 1px solid var(--amber-line);
  border-left: 5px solid var(--amber-line);
  border-radius: 11px;
  padding: 12px 15px;
  color: var(--ink);
  font-size: 14.5px;
}
.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 18px;
}
.cancel {
  color: var(--blue-d);
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
}
.cancel:hover {
  text-decoration: underline;
}
.primary {
  border: 1px solid var(--blue-d);
  background: var(--blue-d);
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  padding: 11px 20px;
  border-radius: 9px;
}
.primary:hover:not(:disabled) {
  background: var(--blue-l);
  border-color: var(--blue-l);
}
.primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
